// NEMESIS Main JavaScript - MBDA Redesign

document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initFormHandler();
});

/* ==========================================
   1. HEADER SCROLL EFFECT
   ========================================== */
function initHeaderScroll() {
  const header = document.getElementById('main-header');
  if (!header) return;
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
}

/* ==========================================
   2. SECURE SIGNAL FORM FEEDBACK
   ========================================== */
function initFormHandler() {
  const form = document.getElementById('secure-signal-form');
  const feedback = document.getElementById('feedback-msg');
  
  if (!form) return;
  
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    
    const serviceMode = document.getElementById('signal-service-mode').value;
    
    // Clear feedback and trigger loader
    feedback.className = 'feedback-msg';
    feedback.style.display = 'none';
    
    const submitBtn = form.querySelector('.pill-btn');
    const loader = form.querySelector('.btn-loader');
    const btnText = form.querySelector('.btn-text');
    
    submitBtn.disabled = true;
    loader.style.display = 'inline-block';
    btnText.textContent = 'ROUTING SIGNAL...';
    
    // Simulated transit latency delay
    setTimeout(() => {
      submitBtn.disabled = false;
      loader.style.display = 'none';
      btnText.textContent = 'TRANSMIT INQUIRY';
      
      feedback.style.display = 'block';
      feedback.className = 'feedback-msg success';
      feedback.innerHTML = `INQUIRY ROUTED SECURELY. [${serviceMode}]`;
      
      form.reset();
    }, 1500);
  });
}
